import PropTypes from 'prop-types';
import React from 'react';

import { twMerge } from 'tailwind-merge';
import GenericCallWidgetBody from './GenericCallWidgetBody';
import GenericCallWidgetFooter from './GenericCallWidgetFooter';
import GenericCallWidgetHeader from './GenericCallWidgetHeader';

const GenericCallWidget = (props) => {
    const { primaryIcon, header, body, footer, darkMode } = props;
    const hasHeader = !!(header && Object.keys(header).length > 0);
    const hasBody = !!(body && body.length > 0);
    const hasFooter = !!(footer && footer.length > 0);

    return (
        <div
            className={twMerge(
                'flex w-auto rounded-sm px-2 py-3',
                darkMode ? 'bg-gray-600' : 'bg-white',
            )}
        >
            <div className="flex min-w-0 flex-1 flex-col leading-normal">
                {hasHeader && (
                    <GenericCallWidgetHeader
                        primaryLabel={header.primaryLabel}
                        actionLabel={header.actionLabel}
                        actionUrl={header.actionUrl}
                        actionIcon={header.actionIcon}
                        actionCallback={header.actionCallback}
                        darkMode={darkMode}
                        primaryIcon={primaryIcon}
                    />
                )}
                {hasHeader && hasBody && <div className="h-2" />}
                {hasBody && (
                    <GenericCallWidgetBody items={body} darkMode={darkMode} />
                )}
                {hasFooter && (
                    <GenericCallWidgetFooter
                        buttons={footer}
                        darkMode={darkMode}
                    />
                )}
            </div>
        </div>
    );
};

GenericCallWidget.propTypes = {
    primaryIcon: PropTypes.node,
    header: PropTypes.shape({
        primaryLabel: PropTypes.string,
        actionLabel: PropTypes.string,
        actionUrl: PropTypes.string,
        actionIcon: PropTypes.node,
        actionCallback: PropTypes.func,
    }),
    body: PropTypes.arrayOf(
        PropTypes.shape({
            primaryLabel: PropTypes.string,
            secondaryLabel: PropTypes.string,
            actionUrl: PropTypes.string,
            actionIcon: PropTypes.node,
            actionCallback: PropTypes.func,
        }),
    ),
    footer: PropTypes.arrayOf(
        PropTypes.shape({
            actionLabel: PropTypes.string,
            actionUrl: PropTypes.string,
            actionCallback: PropTypes.func,
        }),
    ),
    darkMode: PropTypes.bool.isRequired,
    width: PropTypes.number,
};

export default React.memo(GenericCallWidget);
